import { fetchData, postDataAsJson } from "lib/api";
import { BefattningDto, UserDto } from "models";

const AdminBasePath = `admin`;

export async function instanceAdminUserList(): Promise<
  UserDto[]
> {
  const url = `${AdminBasePath}/users`;
  const response = await fetchData(url, {});
  return response;
}

export async function befattningList(): Promise<
  BefattningDto[]
> {
  const url = `${AdminBasePath}/company/users`;
  const response = await fetchData(url, {});
  return response;
}

export async function befattningPost(model: BefattningDto): Promise<
  BefattningDto
> {
  const url = `${AdminBasePath}/company/users`;
  const response = await postDataAsJson(url, model);
  return response;
}

export async function befattningPostBatch(model: BefattningDtoBatch): Promise<
  BefattningDtoBatchResponse
> {
  const url = `${AdminBasePath}/company/usersbatch`;
  const response = await postDataAsJson(url, model);
  return response;
}

export async function befattningDelete(model: BefattningDto): Promise<
  BefattningDto
> {
  const url = `${AdminBasePath}/company/users/${model.id}`;
  const response = await fetchData(url, undefined, {
    method: "DELETE",
    body: JSON.stringify(model),
  });
  return response;
}

export interface BefattningDtoBatch {
  items: BefattningDto[];
}

export interface BefattningDtoBatchResponse {
  items: BefattningDto[];
}

export interface UserRequest {
  email: string;
  firstName: string;
  lastName: string;
}

export interface UserResponse {
  user: UserDto;
}
export async function userPost(model: UserRequest): Promise<
UserResponse
> {
  const url = `${AdminBasePath}/users`;
  const response = await postDataAsJson(url, model);
  return response;
}
